import { useAuth } from "@/context/AuthContext";

export const Footer = () => {
  const { user } = useAuth();
  const hasMobileNav = user && user.has_paid;

  return (
    <footer className={`py-8 md:py-10 px-6 bg-[#1A1A1A] text-white ${hasMobileNav ? 'pb-12 md:pb-10' : ''}`}>
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4">
        <div className="text-center md:text-left">
          <p className="heading-font text-lg md:text-xl font-medium">Emotionell Frihet™</p>
          <p className="text-white/60 text-xs md:text-sm">En metod av Leila Dadgar</p>
        </div>
        <div className="text-center md:text-right space-y-1">
          <p className="text-white/50 text-xs">
            <a href="mailto:leila.dadgar@expressa.se" className="hover:text-white/80 transition-colors">leila.dadgar@expressa.se</a>
            {' · '}
            <a href="https://leiladadgar.se" target="_blank" rel="noopener noreferrer" className="hover:text-white/80 transition-colors">leiladadgar.se</a>
          </p>
          <p className="text-white/40 text-xs">© 2026 Alla rättigheter reserverade</p>
        </div>
      </div>
    </footer>
  );
};
